<!-- 
Next / Previous record buttons.

These are displayed in the top RHS of pages when the record has been navigated to by clicking a record in a listing.
They allow the user to move to the next or previous record from the listing.
-->
<template>
  <span>
    <v-tooltip v-if="previous.available" bottom>
      <v-btn 
        slot="activator" 
        :disabled="previous.atLimit" 
        small icon class="mt-0 mb-0 ml-0 mr-1" 
        @click.stop.prevent="goPrevious"
      >
        <v-icon color="primary" class="mr-0">skip_previous</v-icon>
      </v-btn>
      <span>Previous</span>
    </v-tooltip>
    <v-tooltip v-if="next.available" bottom>
      <v-btn 
        slot="activator" 
        :disabled="next.atLimit" 
        small icon class="mt-0 mb-0 ml-0 mr-2" 
        @click.stop.prevent="goNext"
      >
        <v-icon color="primary" class="mr-0">skip_next</v-icon>
      </v-btn>
      <span>Next</span>
    </v-tooltip>
  </span>
</template>

<script>
export default {
  props: {
    idField: {
      type: String,
      default: "id"
    },
    module: {
      type: String,
      required: true
    },
    navUrl: {
      type: String,
      required: true
    },
    nextPageAction: {
      type: String,
      required: true
    },
    previousPageAction: {
      type: String,
      required: true
    }
  },
  computed: {
    next() {
      return this.$store.state[this.module].view.next;
    },
    previous() {
      return this.$store.state[this.module].view.previous;
    },
    listing() {
      return this.$store.state[this.module].listing;
    }
  },
  methods: {
    async goNext() {
      let id;
      if (this.next.loadPage) {
        await this.$store.dispatch(this.nextPageAction);
        id = this.listing.data[0][this.idField];
      } else {
        id = this.next.id;
      }
      this.go(id);
    },
    async goPrevious() {
      let id;
      if (this.previous.loadPage) {
        await this.$store.dispatch(this.previousPageAction);
        const results = this.listing.data;
        id = results[results.length - 1][this.idField];
      } else {
        id = this.previous.id;
      }
      this.go(id);
    },
    go(id) {
      const url = this.navUrl.replace(":id", id);
      this.$router.push(url);
    }
  }
};
</script>
